import { render, staticRenderFns } from "./btn-arrow-secondary.vue?vue&type=template&id=ab2c7a2e&scoped=true&"
import script from "./btn-arrow-secondary.vue?vue&type=script&lang=js&"
export * from "./btn-arrow-secondary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab2c7a2e",
  null
  
)

export default component.exports